"use client";

import { createTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import type { } from "@mui/x-date-pickers/themeAugmentation";
import type { } from "@mui/x-data-grid-pro/themeAugmentation";

const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: "#566f88",
    },
    secondary: {
      main: "#0d9dda",
    },
  },
  typography: {
    h1: {
      fontSize: "4.5rem",
      lineHeight: "5.625rem",
      letterSpacing: "-2%",
      fontFamily: '"Barlow", Arial, sans-serif',
      fontWeight: 400,
    },
    h2: {
      fontSize: "3.75rem",
      lineHeight: "4.5rem",
      letterSpacing: "-2%",
      fontFamily: '"Barlow", Arial, sans-serif',
      fontWeight: 400,
    },
    h3: {
      fontSize: "3rem",
      lineHeight: "3.75rem",
      letterSpacing: "-2%",
      fontFamily: '"Barlow", Arial, sans-serif',
      fontWeight: 400,
    },
    h4: {
      fontSize: "2.25rem",
      lineHeight: "2.75rem",
      letterSpacing: "-2%",
      fontFamily: '"Barlow", Arial, sans-serif',
      fontWeight: 400,
    },
    h5: {
      fontSize: "1.875rem",
      lineHeight: "2.375rem",
      letterSpacing: "-2%",
      fontFamily: '"Barlow", Arial, sans-serif',
      fontWeight: 400,
    },
    h6: {
      fontSize: "1.5rem",
      lineHeight: "2rem",
      letterSpacing: "-2%",
      fontFamily: '"Barlow", Arial, sans-serif',
      fontWeight: 400,
    },
    body1: {
      fontFamily: '"Inter", Arial, sans-serif',
    },
  },
  components: {
    MuiDataGrid: {
      defaultProps: {
        className: "h-full [&_.MuiDataGrid-cell:focus]:outline-none [&_.MuiDataGrid-row:nth-of-type(even)]:bg-black/[0.04] [&_.MuiDataGrid-row:hover]:cursor-pointer [&_.MuiDataGrid-row:hover]:bg-black/[0.08] [&_.MuiDataGrid-columnHeaders]:bg-gray-50 [&_.MuiDataGrid-columnHeaders]:border-b-2 [&_.MuiDataGrid-columnHeaders]:border-gray-200 [&_.MuiDataGrid-columnHeaders]:font-semibold [&_.MuiDataGrid-columnHeaders]:text-sm [&_.MuiDataGrid-cell]:border-b [&_.MuiDataGrid-cell]:border-gray-200 [&_.MuiDataGrid-cell]:text-sm [&_.MuiDataGrid-cell]:flex [&_.MuiDataGrid-cell]:items-center [&_.MuiDataGrid-footerContainer]:border-t-[3px] [&_.MuiDataGrid-footerContainer]:border-gray-300 [&_.MuiDataGrid-footerContainer]:bg-white [&_.MuiDataGrid-toolbarContainer]:bg-gray-50 [&_.MuiDataGrid-toolbarContainer]:border-b-2 [&_.MuiDataGrid-toolbarContainer]:border-gray-300 [&_.MuiDataGrid-toolbarContainer]:px-4 [&_.MuiDataGrid-toolbarContainer]:py-2 [&_.MuiDataGrid-selectedRowCount]:text-gray-600 [&_.MuiDataGrid-selectedRowCount]:text-sm [&_.MuiDataGrid-row.Mui-selected]:bg-blue-500/[0.12] [&_.MuiDataGrid-row.Mui-selected:hover]:bg-blue-500/[0.16] [&_.MuiDataGrid-row:nth-of-type(even)_.MuiDataGrid-detailPanel]:bg-black/[0.02] [&_.MuiDataGrid-detailPanel]:bg-white",
      },
      styleOverrides: {
        root: {
          fontFamily: '"Inter", Arial, sans-serif',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // matches rounded-lg
        },
        input: {
          "&::placeholder": {
            fontSize: "0.875rem", // text-sm
            color: "#5a5a5a", // neutral-900
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "1000px",
          textTransform: "capitalize",
          fontFamily: '"Inter", Arial, sans-serif',
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
    },
    MuiTab: {
      defaultProps: {
        sx: {
          textTransform: "capitalize",
        },
      },
    },
    MuiAccordion: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          "&::before": {
            display: "none",
          },
        },
      },
    },
    MuiAccordionSummary: {
      defaultProps: {
        className: "flex-row-reverse gap-2 min-h-0 my-0 p-0",
        slotProps: {
          content: {
            sx: {
              "&.Mui-expanded": {
                margin: "16px 0",
              },
            },
          },
        },
      },
    },
    MuiAccordionDetails: {
      defaultProps: {
        // Remove className, use sx for padding
        sx: {
          padding: 0,
        },
      },
    },
  },
});

export default theme;
